// extracted by mini-css-extract-plugin
module.exports = {"Badge":"RiveBadge_Badge__lJQGj","BadgePrimary":"RiveBadge_BadgePrimary__VFrnr","BadgeStandard":"RiveBadge_BadgeStandard__k5xMR"};